import * as wf from "client-api-workflow";
import { WFDelegateParams } from "client-api-workflow/types";
import React from "react";
import { useMutation, useQueryClient } from "react-query";

const useSubmitEscalateTask = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  // was: types.MeasurePayload

  return useMutation(async (params: WFDelegateParams) => {
    return wf.escalate(params);
  }, invalidateCache);
};

export default useSubmitEscalateTask;
